module.exports = __webpack_public_path__ + "static/padding-ab340665ec531eaeba630f60d974ba4d.png";